/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmResponsesCancel } from "../../funcs/llmResponsesCancel.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CancelResponseRequest$inboundSchema,
};

export const tool$llmResponsesCancel: ToolDefinition<typeof args> = {
  name: "llm-responses-cancel",
  description: `Cancel an in-progress background response

Cancels an agent response that is currently processing in the background.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmResponsesCancel(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
